var _linearGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseWave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#EFF2FB",
    height: 408,
    viewBox: "0 0 1440 408",
    width: 1440,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 1047.5,
    x2: 1047.5,
    y1: 252.723,
    y2: -29
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1244 170c-178.5-88.723-378.517-154.7564-600.5-135.7769-221.983 18.9796-180.472-11.552-345.86-30.09809-165.388-18.54611-268.5176 30.31159-347.6401 50.09219 0 87.9328-.0003 353.0058-.0003 353.0058h1522.1004v-219.223s-23.54 83.675-228.1-18z",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseWave2);
export default __webpack_public_path__ + "static/media/course-wave2.876d211ef23ac1c9c5f09104528118cb.svg";
export { ForwardRef as ReactComponent };